import React, { useState } from "react";
import { Form, Input, Button, Typography, message, Spin, Divider, Row, Col } from "antd";
import { useHistory } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";
import { RightOutlined } from '@ant-design/icons';
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../constants/constants";
import _BankAdminService from "../../modules/BankAdminService";
import Login from "../../components/Login/Login";


const { Title, Link } = Typography;

const BankAdminLogin = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const reqObj = {
                Email: values.email,
                Password: values.password,
            }
            const res = await _BankAdminService.bankAdminLogin(reqObj);
            console.log(res);
            if (res?.data.IsSuccess) {
               // message.success(res.data.Message);
                localStorage.setItem("IsLoanofficerFlag", JSON.stringify(false));
                localStorage.setItem("IsBankAdminFlag", JSON.stringify(true));
                localStorage.setItem("BankAdminEmailId", res?.data?.Obj?.Email);
                localStorage.setItem("BankAdminId", res?.data?.Obj?.Id);
                localStorage.setItem("BankAdminFirstName", res?.data?.Obj?.FirstName);
                localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
                localStorage.setItem("userRole", res?.data?.Obj?.Role);
                history.push(routes.bankadmindashboard.path);
                setLoading(false);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG)
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        }

    };

    const forgotPassword = () => {
        history.push(
            routes.forgotBankerLoginPasswordSendOTP.path,
            { isFromBankAdmin:true }
        )
    };

    const bankerLogin = () => {
        history.push(routes.accountLogin.path);
    }

    const bankerAdminLogin = () => {
        history.push(routes.bankAdminLogin.path);
    }

    const loanOfficerLogin = () => {
        history.push(routes.accountLoginForLoanOfficer.path);
    }

    const complianceAdminLogin = () => {
        history.push(routes.complianceAdminLogin.path);
    }

    const applicantLogin = () => {
        history.push(routes.registeredEmail.path);
    }
    
    const createNewAccount = () => {
        history.push(routes.createBankAdminAccount.path);
    }

    return (
        <Spin spinning={loading}>
            <Login 
                role="bankAdmin"
                title="Bank Admin Portal"
                onFinishHandle={onFinish}
                createNewAccount={createNewAccount}
                forgotPassword={forgotPassword}
                bankerLogin={bankerLogin}
                bankerAdminLogin={bankerAdminLogin}
                loanOfficerLogin={loanOfficerLogin}
                complianceAdminLogin={complianceAdminLogin}
                isNewAccountCreateFlag={true}
                applicantLogin={applicantLogin}
            />
            {/* <LeftLayout>
                <div className="w450 bank-login-page">
                    <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3", marginBottom: 60 }}>
                        Bank Admin Portal
                    </Title>


                    <Form
                        name="account-login"
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={true}
                    >
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: "Email is required",
                                },
                                { type: 'email', message: 'Enter a valid Email' }
                                // {
                                //     pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|in|org|net|edu|gov|co|ai|us|info|biz|me|io|tech|app|dev|cloud|store|xyz|tv|name|email|pro|mil|k12|state)$/,
                                //     message: "Please enter a valid email address with a valid domain (e.g., .com, .in)",
                                // },
                            ]}
                        >
                            <Input autoComplete="email" placeholder="Enter Your Email" maxLength={50} />
                        </Form.Item>

                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: "Password is required" }]}
                        >
                            <Input.Password autoComplete="current-password" placeholder="Enter Password" maxLength={30} />
                        </Form.Item>
                        <div style={{ textAlign: "right", marginTop: 8 }} className="forgot-text">
                            <Link
                                onClick={() => history.push(
                                    routes.forgotBankerLoginPasswordSendOTP.path,
                                    { isFromBankAdmin:true }
                                )}
                                style={{ fontWeight: "bold" }}
                            >
                                Forgot Password? <RightOutlined />
                            </Link>

                        </div>

                        <Row justify="space-between" align="middle" style={{ marginTop: 8 }}>
                            <Col>
                                <Form.Item style={{ marginBottom: 0 }}>
                                    <Button
                                        htmlType="submit"
                                        className="login-btn"
                                        shape="round"
                                        style={{
                                            borderColor: "#001f3f",
                                            color: "#001f3f",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Login <RightOutlined />
                                    </Button>
                                </Form.Item>
                            </Col>
                            <Col>
                                <Link
                                    onClick={() => history.push(routes.createBankAdminAccount.path)}
                                    style={{ fontWeight: "bold" }}
                                >
                                    Create A New Account <RightOutlined />
                                </Link>
                            </Col>
                        </Row>

                    </Form>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: 15,
                        }}
                    >
                      
                        
                    </div>
                      <Divider plain orientation="center">
                        OR
                    </Divider>
                    <Form.Item className="mt20 mb10">
                        <Link onClick={() => history.push(routes.accountLogin.path)}>
                            Banker Login <RightOutlined />
                        </Link>
                    </Form.Item>
                    <Form.Item className="mb10">
                        <Link onClick={() => history.push(routes.registeredEmail.path)}>
                            Applicant Login <RightOutlined />
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Link onClick={() => history.push(routes.accountLoginForLoanOfficer.path)}>
                            Loan Officer Login <RightOutlined />
                        </Link>
                    </Form.Item>
                  
                </div>
            </LeftLayout> */}
        </Spin>
    );
};

export default BankAdminLogin;
